<template>
  <a class="product-tile" :class="{'product-tile--force-mobile': forceMobile}" :href="url" :id="id" tabindex="0" aria-live="polite" :aria-label="product.title">
    
    <div class="product-tile__badge-container">
      <span
        class="product-tile__badge badge"
        v-if="productBadge"
        :style="badgeStyles"
      >
        {{ productBadge }}
      </span>
    </div>
    <span class="pftm__review-stars-container">      
    <product-reviews-badge
      :product="product"
      :settings="{}"
    ></product-reviews-badge>

    </span>
    <div class="product-tile__images">
      <img class="product-tile__img-main" :src="imageSize(images.default, '304x')" :alt="images.defaultAlt" :srcset="`${imageSize(images.default, '168x')} 168w, ${imageSize(images.default, '304x')} 304w, ${imageSize(images.default, '456x')} 1.5x`"/>
      <img class="product-tile__img-hover" :src="imageSize(images.hover, '304x')" :alt="images.hoverAlt" :srcset="`${imageSize(images.hover, '168x')} 168w, ${imageSize(images.hover, '304x')} 304w, ${imageSize(images.hover, '456x')} 1.5x`"/>
      <product-featured-badges v-if="product.featuredBadges" :badges="product.featuredBadges" />
    </div>
    <div class="product-tile__static-text-content" :class="[textAlignment, 'product-tile__static-text-content--collection']">
      <div class="row">
        <div class="col-12-sm">
          <span class="product-tile-vendor-name">{{ product.vendor }}</span>
        </div>
        <div class="col-12-sm product-tile__title">
          <span class="product-tile-title body-sm">{{ staticProductName }}</span>
        </div>
        <div class="col-12-sm product-tile__type color-grey" v-if="product.product_fit || product.product_type">
          <span class="product-tile-type body-sm">{{ staticProductType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="product-tile__price-container" v-if="!product.hidePrice">
          <span class="product-tile__price product-tile__compare-price" :class="{'color-util-sale' : onSale}">
            {{ variant.price | moneyWithoutDecimals }}
          </span>
          <span class="product-tile__price color-black" v-if="onSale">
            <s>{{ variant.compare_at_price | moneyWithoutDecimals }}</s>
          </span>
        </div>
        <div v-if="collection && product.short_description" class="col-12-sm product-tile__description">
          <span>{{ product.short_description }}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import ProductFeaturedBadges from './ProductFeaturedBadges.vue'
import ProductTileSimple from './ProductTileSimple.vue'
import ProductReviewsBadge from '@/scripts/components/product/ProductReviewsBadge.vue'

export default {
  components: {
    ProductFeaturedBadges,
    ProductReviewsBadge
  },
  name: 'ProductTileSimpleArticle',
  extends: ProductTileSimple,
  props: {
    forceMobile: { // force mobile text size on desktop widths
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.pftm__review-stars-container {
  position: absolute;
  right: 5px;
  top: 12px;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right:7px;
}
.yotpo-number-rating {
  height: 12px;
  width: 32px;
  color: $color-black-700;
  font-family: $font-family-secondary;
  font-size: 12px;
  letter-spacing: -0.2px;
  line-height: 12px;
  text-align: center;
}
.badge {
  color: #ffffff;
  background-color: rgb(51, 50, 50);;
  margin-left: 12px;
  margin-top: 12px;
}
.product-tile {
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: column;
  color: inherit;
  cursor: pointer;
  // height: 532px;
  background: $color-black-100;
  text-decoration: none;

  @include mobile-only {
    // height: 297px;
  }

  @include ie {
    display: block;
  }

  /* Fixes iOS :hover issue where it ignores click */
  @media (hover: hover) {
    &:hover &__img-hover,
    &:focus &__img-hover {
      opacity: 1;
    }
  }

  .row > * {
    margin-bottom: 0;
  }

  .button-row {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 8px;
    @include mobile-tablet {
      .button__content {
        font-size: 12px;
      }
    }
  }

  &__price {
    @include product-tile-price;
    font-family: $font-family-primary;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;

    @include mobile-only {
      font-size: 13px;
      line-height: 15px;
    }
  }
  &__description {
    color: $color-black-600;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 12px;
    text-align: center;
    margin-bottom: 0;
  }

  @media screen and (max-width: 400px) {
    max-width: 100%;
  }

  a {
    line-height: normal;
  }

  &-title {
    font-size: 17px;
    line-height: 25px;
    color: $color-text-soft-black;
    @include mobile-only {
      font-size: 15px;
      line-height: 15px;
    }
  }

  &-color {
    font-size: rem(12);
    line-height: 1em !important;
  }

  &__images {
    position: relative;
    font-size: 0;
    // height: 200px;
    @include tablet-up {
      // height: 400px;
    }
    width: 100%;
    background-color: $color-white;
  }

  &__images a {
    font-size: 0;
    width: 100%;
    height: 100%;
  }

  &__img-hover {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.2s linear;
  }

  &__img-main {
    z-index: 2;
    position: relative;
    transition: none;
    transition: opacity 0.2s linear;
  }

  &__img-hover {
    z-index: 5;
  }

  &__img-main--placeholder {
    width: 100%;
    height: 100%;
    z-index: 4;
    fill: $color-lightest-grey;
  }

  &__img-main,
  &__img-hover {
    width: 100%;
    height: 100%;
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }

  &__static-text-content {
    bottom: 48px;
    text-align: center;
    z-index: 2;
    width: 100%;
    padding: 0 0 18px;
  }

  &__img-main--placeholder {
    width: 100%;
    height: 100%;
  }

}
.product-tile-vendor-name {
  color: $color-black-700;
  font-size: 12px;
  line-height: 1.33;
  white-space: normal;
}

.product-tile.product-tile--force-mobile {
  .product-tile-vendor-name {
    font-size: 11px;
    line-height: 12px;
    white-space: normal;
  }

  .product-tile-title, .product-tile__title {
    font-size: 14px;
    line-height: 15px;
  }

  .product-tile__price {
    font-size: 13px;
    line-height: 15px;
  }

  .product-tile__static-text-content {
    padding-bottom: 13px;
  }
}
</style>
